<template>
<div class="header">

</div><!--header 结束-->
</template>

<script>
  import auth from '../../auth/auth'
  export default{
      data(){
          return{

        }
      },
      computed:{

      },
      watch:{

      },
      methods:{

      },
    created(){

    },
     mounted(){

     },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// AccountAdminHeader.vue?081ea1aa